const translations = {
    applicationNameFieldPlaceholder: 'Application Name'
};

export default translations;
